module.exports = __webpack_public_path__ + "static/media/avatar-1-dina.2e267bca.jpg";